import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';

export default action(
    'MOVE_ITEMS_BASED_ON_NODE_IDS',
    (
        nodeIds: string[],
        destinationFolderId: string,
        tableViewId: string,
        actionSource: ActionSource
    ) => ({
        nodeIds,
        destinationFolderId,
        tableViewId,
        actionSource,
    })
);
